import { useStores } from 'config/store'

export default function useCurrentUser() {
  const { appState } = useStores()
  const { profileEmail } = appState
  return { profileEmail }
}
